import React from "react";
import { ThemeProvider, Typography, Link, Box } from "@mui/material";
import colorTheme from "../assets/colorTheme";
import { StyledFooterBox, StyledIconBox } from './Footer.styles';

const Footer : React.FC = () => {
    return (
        <ThemeProvider theme={colorTheme}>
            <StyledFooterBox>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0, width: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                        <Link href="https://www.docutech.com/about-us" underline="hover" color="primary" target="_blank" rel="noopener noreferrer">
                            <StyledIconBox>
                                <Typography variant="caption">
                                    ABOUT US
                                </Typography>
                            </StyledIconBox>
                        </Link>

                        <Link href="https://www.firstam.com/privacy-policy/?hsLang=en" underline="hover" color="primary" target="_blank" rel="noopener noreferrer">
                            <StyledIconBox>
                                <Typography variant="caption">
                                    PRIVACY NOTICE
                                </Typography>
                            </StyledIconBox>
                        </Link>
                        
                        <Link href="https://www.firstam.com/terms-of-use/?hsLang=en" underline="hover" color="primary" target="_blank" rel="noopener noreferrer">
                            <StyledIconBox>
                                <Typography variant="caption">
                                    TERMS OF USE
                                </Typography>
                            </StyledIconBox>
                        </Link>
                        
                        <StyledIconBox>
                            <Typography variant="caption">
                                EPC | {process.env.REACT_APP_ENVIRONMENT || ""}
                            </Typography>
                        </StyledIconBox>
                    </Box>
                    <Typography variant="caption" sx={{fontSize: '0.7rem', color: 'text.secondary'}}>
                       ©2026 First American Financial Corporation and/or its affiliates. All rights reserved.
                    </Typography>
                </Box>
            </StyledFooterBox>
        </ThemeProvider>
    ); 
};

export default Footer;